import { render, staticRenderFns } from "./CarregarBannerCodigoPromocional.vue?vue&type=template&id=26498c98&"
import script from "./CarregarBannerCodigoPromocional.vue?vue&type=script&lang=js&"
export * from "./CarregarBannerCodigoPromocional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports